
class CapViewAllPendingNotifications {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_all_pending_notifications'
}

function create(config) {
  return new CapViewAllPendingNotifications(config)
}

export default {
  key,
  create,
}
